import { render } from "./UIMarkdownEditor.vue?vue&type=template&id=25376e2c&scoped=true"
import script from "./UIMarkdownEditor.vue?vue&type=script&lang=js"
export * from "./UIMarkdownEditor.vue?vue&type=script&lang=js"

import "./UIMarkdownEditor.vue?vue&type=style&index=0&id=25376e2c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25376e2c"]])

export default __exports__